export const formatReleaseDate = (
  releaseDate: string,
  locale: string = 'en-US',
  options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  },
) => {
  return new Date(releaseDate).toLocaleDateString(locale, options)
}
